export enum AssignShipmentAction {
  Override = 'Override',
  Assign = 'Assign',
  AssignAndAutoStart = 'AssignAndAutoStart'
}
